import React, { useContext, useEffect } from 'react'
import { TopbarContext } from './TopbarContext'

function Container({ children, className, id, style, topbarTitle, onScroll }) {
    const topbar = useContext(TopbarContext)

    useEffect(()=>{
        topbar.setTopTitle(topbarTitle)
    },[])

    return (
        <div 
        id={id} 
        onScroll={onScroll}
        className={className}>
            {children}
        </div>
    )
}

export default Container
